import * as React from 'react';
import { CheckMarkIcon, LeftArrowIcon } from '../Icons';
import { PageRoutes } from '../../root/Routes';
import { Link } from 'react-router-dom';

interface CardHeaderProps {
    email?: string;
    message?: string | JSX.Element;
    verifyEmail?: JSX.Element;
    redirectMessage?: string;
    authStep?: string;
    history?: any;
    step?: string;
}

export function CardHeader(props: CardHeaderProps): JSX.Element {
    const location = window.location.pathname;

    return(
        <header>
            {((location === PageRoutes.PasswordStep || location === `/webportal${PageRoutes.PasswordStep}`) ||
                (location === PageRoutes.ResetPassword || location === `/webportal${PageRoutes.ResetPassword}`)) &&
                <div className="auth_back">
                    <Link to={{ pathname: props.step, state: { email: props.email, step: location } }}>
                        <LeftArrowIcon width={'20px'} height={'20px'} fill={'#4C85C8'} />
                    </Link>
                    <span className="autohide">{props.email}</span>
                </div>}
            <div className="auth_heading">
                <h1>{props.message}</h1>
                <div className="center">
                    {props.verifyEmail}
                    {props.redirectMessage &&
                        <div className="extended__field left alert alert-success sign__up__success__redirect__alert" role="alert">
                            <CheckMarkIcon className="alert__icon" width="21px" />
                            <span>{props.redirectMessage}</span>
                        </div>}
                </div>
            </div>
        </header>
    );
}


// WEBPACK FOOTER //
// ./src/webportal/components/common/authenticationCardComponents/CardHeader.tsx